/**
 * React hook to return the current user's ID
 */

import { useEffect, useState } from 'react';

import { getCurrentUserId } from '../../../services/auth';
import { CacheKey } from '../../common/constants';

const useUserId = () => {
  const [userId, setUserId] = useState<string>(() => localStorage.getItem(CacheKey.UserId) || '');

  // The cached ID is only a first-paint value: it survives sign-out and belongs
  // to whoever signed in last, so the session is always re-checked
  useEffect(() => {
    const fetchId = async () => {
      const id = await getCurrentUserId();
      if (id === undefined) {
        return;
      }

      // Every consumer holds its own state but they share one cache entry, so
      // the ID is adopted whether or not this hook is the one that cached it:
      // gating the state on the cache changing leaves each consumer that lost
      // the race blank for the life of its mount
      localStorage.setItem(CacheKey.UserId, id);
      setUserId(id);
    };

    fetchId();
  }, []);

  return userId;
};

export default useUserId;
